import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 tenant_add_sales_rep_to_agency: { message: "idle" },
};

export const tenant_add_sales_rep_to_agency_Slice = createSlice({
 name: "tenant_add_sales_rep_to_agency",
 initialState,
 reducers: {
  success_tenant_add_sales_rep_to_agency: (state, action) => {
   state.tenant_add_sales_rep_to_agency = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_tenant_add_sales_rep_to_agency: (state, action) => {
   state.tenant_add_sales_rep_to_agency = { status: app_consts.FAIL, message: action.payload };
  },
  reset_tenant_add_sales_rep_to_agency: (state) => {
   state.tenant_add_sales_rep_to_agency = { status: app_consts.IDLE };
  },
  loading_tenant_add_sales_rep_to_agency: (state) => {
   state.tenant_add_sales_rep_to_agency = { status: app_consts.LOADING };
  },
 }
});

export const { success_tenant_add_sales_rep_to_agency, fail_tenant_add_sales_rep_to_agency, reset_tenant_add_sales_rep_to_agency, loading_tenant_add_sales_rep_to_agency } = tenant_add_sales_rep_to_agency_Slice.actions;

export default tenant_add_sales_rep_to_agency_Slice.reducer;